import {booleanSchema, RecordSchema, recordSchema, stringSchema} from '@lightweightform/storage';

import {convertDatesAtPathsJson2Js, convertDatesAtPathsJs2Json, sharedSchemas} from '../../shared';
import {pt} from 'oss-registo-kotlin-common-js';

const {bankAccountInfoSchema, makeRegistrationSchema, vatIdSchema, OssSchemaType} = sharedSchemas;

const {
  IdentOfBusinessValidator,
  NON_UNION_NAT_TAX_VALIDATOR,
} = pt.at.oss.kotlin.manual.validator.common;

const FieldSizeConstants = pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants;
const {
  TAX_REF_NUM_MIN_LEN,
  TAX_REF_NUM_MAX_LEN,
  ISSUING_COUNTRY_LEN,
} = FieldSizeConstants;


/**
 * Date conversion functions
 **/
const NON_UNION_DATE_PATHS = [
  ['relevantDates', 'registrationReqDate'],
  ['relevantDates', 'forecastStartDate'],
  ['relevantDates', 'msidDecisionDate'],
  ['supplyCommencement', 'commencementDate'],
];
export function convertDatesNonUnionJson2Js(nonUnionForm) {
  return convertDatesAtPathsJson2Js(NON_UNION_DATE_PATHS)(nonUnionForm);
}
export function convertDatesNonUnionJs2Json(nonUnionForm) {
  return convertDatesAtPathsJs2Json(NON_UNION_DATE_PATHS)(nonUnionForm);
}

/**
 * Non-Union form schema.
 */
export const nonUnionormSchema: RecordSchema = makeRegistrationSchema({

  issuingCountry: stringSchema({
    minLength: ISSUING_COUNTRY_LEN.toInt(),
    maxLength: ISSUING_COUNTRY_LEN.toInt(),
  }),
  nationalTaxNumber: stringSchema({
    minLength: TAX_REF_NUM_MIN_LEN.toInt(), maxLength: TAX_REF_NUM_MAX_LEN.toInt(),
    validations: [
      ctx => NON_UNION_NAT_TAX_VALIDATOR.validateTaxRefFormat(ctx.get()) ?? undefined
    ]
  }),

  currVatId: recordSchema({
    issuingCountry: stringSchema(),
    vatIdNum: stringSchema(),
  }, {isClientOnly: true}),

  bankAccountInfo: bankAccountInfoSchema(true),

  notEstablishedInEU: booleanSchema({initialValue: true, allowedValues: [true]}),

}, OssSchemaType.NON_UNION, [
  ctx => IdentOfBusinessValidator.validateEqualCountryAndIssuer(ctx.get('./countryOfBusiness'), ctx.get('./cobRegion'), ctx.get('./issuingCountry'), false) ?? undefined,
  ctx => IdentOfBusinessValidator.validateIssuer(ctx.get('./issuingCountry')) ?? undefined,
  ctx => {
    return IdentOfBusinessValidator.validateNatTaxRefMandatoryIssuer(ctx.get('./cobRegion'), ctx.get('./issuingCountry')) ?? undefined
  }
]);
